import { useEffect } from 'react';

import RequestState from '../../types/RequestState';

const useFetchManufacturers = ({ manufacturerStore }) => {
  useEffect(() => {
    if (
      !manufacturerStore.loadedWithContent &&
      manufacturerStore.state !== RequestState.LOADING
    ) {
      manufacturerStore.loadManufacturers({ excludeContent: false });
    }
  }, []);
};

export default useFetchManufacturers;
